import React from "react";
import { useState } from "react";

import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';


const SnackBox = () => {
  const [display, setDisplay] = useState(false);
  const [msg, setMsg] = useState(false);

  SnackBox.setDisplay = setDisplay;
  SnackBox.setMsg = setMsg;
  
  return (
    <Snackbar
      open={display}
      autoHideDuration={3000}
      anchorOrigin={ {vertical:"bottom", horizontal:"right"} }
      onClose={SnackBox.onClose}
      message={msg}  
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={SnackBox.onClose}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      }
    />
  );
};

SnackBox.onClose = (event, reason) => {
  if (reason === 'clickaway') {
    return;
  }

  SnackBox.setDisplay(false);
}

SnackBox.showAlert = (msg) => {
  SnackBox.setDisplay(true);
  SnackBox.setMsg(msg);
}


export default SnackBox;
